import React from 'react';
import { useChannelIOApi } from 'react-channel-plugin';
import { Button } from '../../Components/StyledComponents';
import './ReqOrder.scss';

const ReqOrder = () => {
    const { showMessenger } = useChannelIOApi();

    return (
        <div className='req-order'>
            <div className='row' style={{marginBottom: 24}}>
                <p className='text'>중개 수수료 없는,</p>
                <p className='title' style={{margin: 0}}>&nbsp;시럽프렌즈 오더!</p>
            </div>
            <p className='desc'>수수료 대신 고객분들에게 추가 혜택을 제공하여,</p>
            <p className='desc'>재주문율을 높이고 매출을 상승시키는</p>
            <p className='desc'>시럽프렌즈 오더!</p>
            <p className='req-text'>지금 바로 시럽프렌즈 오더를 이용하시려면 아래 버튼을 눌러 상담을 진행해주세요!</p>
            <Button variant='sub' style={{ width : 114, marginTop : 32 }} onClick={showMessenger}>
                오더 오픈하기
            </Button>
        </div>
    )
}

export default ReqOrder;